module.exports = __webpack_public_path__ + "img/3-rooms.dc893757.png";